module.exports = __webpack_public_path__ + "img/svg/no-money.a8189b868ed2b2e46fba2f096f08d322.svg";